export enum PaymentTypeMethods {
  stripe = 'stripe',
}
